import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules'; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import 'swiper/css';
import 'swiper/css/navigation';

const Gifts = () => {
    const [heartIconsVisibility, setHeartIconsVisibility] = useState(Array(9).fill(false)); 

    const toggleHeart = (index) => {
      const newVisibility = [...heartIconsVisibility];
      newVisibility[index] = !newVisibility[index]; 
      setHeartIconsVisibility(newVisibility);
    };

    return (
        <div className='mt-5 coverer-fluid'>
            <div className="d-flex gap-2 justify-content-between align-items-center px-3 mb-4">
                <img src="images/Group 77.png" className='category-title' alt="" />
                <div className="main-bg hovers px-3 py-2 text-white rounded-pill">See More</div>
            </div>
            <Swiper
                className='px-5 pb-5'
                modules={[Navigation]} 
                navigation 
                spaceBetween={100} 
                breakpoints={{
                    640: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 4 },
                }}
                loop
            >
                {[...Array(9)].map((_, index) => (
                    <SwiperSlide key={index}>
                        <div 
                            className="card rounded-5 h-100 position-relative"
                            style={{
                                backgroundImage: "url('images/flower-5.png')",
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "top",
                                paddingTop: "178px",
                            }}
                        >
                            {heartIconsVisibility[index] ? (
                                <FontAwesomeIcon
                                    icon={faHeart}
                                    className="text-danger arrivals-heart-icon position-absolute"
                                    onClick={() => toggleHeart(index)} 
                                />
                            ) : (
                                <img
                                    src="images/heart-thin.png"
                                    className="arrivals-heart-image position-absolute"
                                    alt=""
                                    onClick={() => toggleHeart(index)} 
                                />
                            )}

                            <div className="d-flex justify-content-end align-items-center pe-2 pb-2">
                                <img src="images/bi_cart.svg" className="hovers" alt="" />
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default Gifts;
